import React from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import pic from '../../../../images/pic.svg'
import { recommendedJobs } from '../../../../data'

import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Card } from 'react-bootstrap'


const EmployerDashboard = () => {
  return (
    <div>
      <EmployerNavbar/>
      <Container fluid className='dashboard-section p-5'>
          
          <div className='d-flex justify-content-between align-items-center'>
            <div className='dashboard-header mt-3'>
              <h4>Hello Cynthia</h4>
              <p>Welcome to your Dashboard! Find out what's happening.</p>
           </div>
           <img className='dashboard-img'src={pic}/>
          </div>
          <div className='apply-line'></div>
          <Row className='gap-4 mt-5 pt-2'>
            <Col  xs={12} lg={6} className=''>
            <h1 className=''>Posted Jobs</h1>
            <Row className='mt-4 gap-3'>
            {recommendedJobs.map((jobs) => {
             const {id,
             image,
              role,
              company,                    amount,
              frequency,
              period,
              workMode,                  icon,
             } = jobs;
              return(                  <Card className='p-3 ' style={{  background: '#CCCCDD'}}>
                <Row className='align-items-center'>
                  <Col xs={4} sm={3} md={2} lg={3}xl={2}className=''>
                    <img className='' src={image} style={{width:'100px', height:'80px'}}/>
                  </Col>
                  <Col className='d-flex flex-column gap-2 mt-1 dashboard-recommend-details'>
                  
                    <h4>{role}</h4>
                    <h5>{company}</h5>

                    <div className='top-div'>
                      <button className='period-btn'>{period}</button>
                      <p> <img src={icon}/>{workMode}</p>
                    </div>
                    <h6>Salary Range: {amount}&nbsp;<span>({frequency})</span></h6>
                  
                  </Col>
                  <Col sm={3} className='d-flex flex-column gap-2 px-3'>
                 
                    <button className='dashboard-apply-btn'>Edit</button>
                    
                  
                  </Col>
               
                
                </Row>
              </Card>
              )                    
              })}
            </Row>

            </Col>
            <Col >
              <Row className='gap-4'>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head '>Your Profile</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='py-3 d-flex justify-content-between align-items-center' >
                    <p className='card-p'>Unlock new features by completing your Profile</p>
                    <Link to='/employerprofile'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Viewed Posts</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='py-3 d-flex justify-content-between align-items-center' >
                    <p className='card-p'>Find out if anyone has viewed your job posts</p>
                    <Link to='/feedback'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Your Notifications</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='py-3 d-flex justify-content-between align-items-center' >
                    <p className='card-p'> You have no Notifications Yet</p>
                    <Link to='/employernotifications'>
                    <FaArrowRight className='arrow-right'/>
                    </Link>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}className='py-3'>
                  <h4 className='card-head'>Post Jobs</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='py-3 d-block d-sm-flex justify-content-between align-items-center ' >
                    <p className='card-p'>Would you like to recruit talents for a job?</p>
                    <div className='d-flex justify-content-center 
                    align-items-center text-center '>
                    <Link to='/postjobs' className=' dashboard-alert-btn text-decoration-none'>
                    Post a Job
                  </Link>
                  </div>
                    </Card.Text>
                  </Card.Body>

                </Card>
                <Card className='m-0 p-0'>
                  <Card.Header style={{background: '#CCCCDD'}}>
                  <h4 className='card-head'>How to Recruit the Right Talents</h4>
                  </Card.Header>
                  <Card.Body style={{background: '#e9e8e8'}}>
                    <Card.Text className='py-3 d-flex justify-content-between align-items-center' >
                    <div className='card-p  flex-column'>
                  <a href='#'>Check out our latest recruitment articles and get tips</a>
                  <br/> <br/>
                  <a href='#'>Join our HR trainings and webinars today</a>
                </div>
                    </Card.Text>
                  </Card.Body>

                </Card>
              </Row>

            </Col>
          </Row>
          
        </Container>
      
    </div>
  )
}

export default EmployerDashboard
